<template>
  <div>
    <div id="section-4-top">
      <div class="row row-0">

        <div class="col-sm-6">
          <img src="../assets/images/picture.png" class="img-full img-fluid" alt="" />
        </div>

        <div class="col-sm-6">
          <div class="section-4-content">
            <h3>
              pas de mauvaise surprise :
              <br />toutes vos dépenses
              <br />sont consultables en ligne !
            </h3>
            <p>
              Vous pouvez consulter à tout moment le montant et le détail de vos dépenses effectuées par carte en magasin ou
              sur Internet depuis votre application Ma banque<sup>(2)</sup> et votre Espace Crédit Agricole en ligne.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <p class="text-center">
        <a
          :href="cta"
          class="the-button"
          target="_top"
          data-trackingclass="landing-page-clic-bouton"
          data-trackinginfo="landing-page-CAPS-debitdiffere-cta-rdv-bas"
        >
          demandez le Débit Différé pour votre carte
        </a>
      </p>
      <p class="disclaimer-2">
        (1) Offre soumise à conditions et à l'acceptation de votre Caisse régionale. Le montant de chaque opération effectuée
        à l’aide de cette carte est débité directement et intégralement sur le compte du client, après vérification automatique
        et systématique du solde (ou provision) disponible sur son compte. Renseignez-vous auprès de votre Caisse régionale
        pour connaître les conditions de l’offre et le calendrier des prélèvements.
        <br />(2) Téléchargement et accès gratuits à l’application Ma banque, hors coûts de communication selon opérateurs.
        L’utilisation de l’application nécessite la détention d’un terminal de communication compatible avec accès à internet
        et l’abonnement au service Crédit Agricole En Ligne. (service facturé selon le barème tarifaire en vigeur dans votre Caisse régionale).
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cta: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Informations.vue